<template>
  <div class="page__create_voucher">
    <strong style="font-size: 15px">{{ $t('base.basic_info') }}</strong>
    <br>
    <br>

    <table v-if="component_state === 'update_file' && copy_from_file">
      <tbody>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right;">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('base.filename') }}</div>
        </td>
        <td style="width: 300px">
          <el-input size="mini" v-model="copy_from_file.name"></el-input>
        </td>
      </tr>
      </tbody>
    </table>

    <table>
      <tbody>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right;">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.type') }}</div>
        </td>
        <td style="width: 1000px">
          <div style="margin-top: 20px">
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'shop' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'shop'">
                <el-card :shadow="type === 'shop' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0Ljg3NSA1LjYyNWEyLjE4MyAyLjE4MyAwIDAxLTIuMTg4IDIuMTg4QTIuMTgzIDIuMTgzIDAgMDExMC41IDUuNjI0YTIuMTgzIDIuMTgzIDAgMDEtMi4xODcgMi4xODggMi4xODMgMi4xODMgMCAwMS0yLjE4Ny0yLjE4OCAyLjE4MyAyLjE4MyAwIDAxLTIuMTg4IDIuMTg3IDIuMTc5IDIuMTc5IDAgMDEtMS44My0uOTkgMi4xNzQgMi4xNzQgMCAwMS0uMzU3LTEuMTg1di0uMDEybC42Mi0yLjQ4MUEyLjUgMi41IDAgMDE0Ljc5NiAxLjI1aDExLjQwOGEyLjUgMi41IDAgMDEyLjQyNiAxLjg5NGwuNjIgMi40OFY1LjYzOGEyLjE3NyAyLjE3NyAwIDAxLS4zNTcgMS4xODYgMi4xOCAyLjE4IDAgMDEtMS44My45OSAyLjE4MyAyLjE4MyAwIDAxLTIuMTg4LTIuMTg3ek0zIDguOTMzVjE3LjVjMCAuNjkuNTYgMS4yNSAxLjI1IDEuMjVoMTIuNWMuNjkgMCAxLjI1LS41NiAxLjI1LTEuMjVWOC45MzNhMy40NCAzLjQ0IDAgMDEtMy4xMjUtLjY1NiAzLjQyMyAzLjQyMyAwIDAxLTIuMTg4Ljc4NiAzLjQyMyAzLjQyMyAwIDAxLTIuMTg3LS43ODYgMy40MjQgMy40MjQgMCAwMS0yLjE4OC43ODYgMy40MjMgMy40MjMgMCAwMS0yLjE4Ny0uNzg2QTMuNDQgMy40NCAwIDAxMyA4LjkzM3ptOC4yMDggNi4wNjZhLjU3OS41NzkgMCAwMC0uMjItLjQ4MyAyLjY3NSAyLjY3NSAwIDAwLS43NjgtLjM1NyA3LjI3MyA3LjI3MyAwIDAxLS44OTktLjM1OGMtLjc1OC0uMzcxLTEuMTM3LS44ODItMS4xMzctMS41MzNhMS4zOCAxLjM4IDAgMDEuMjgtLjg1NmMuMjEtLjI2My40ODgtLjQ2My44MDQtLjU3OWEzLjEyMSAzLjEyMSAwIDAxMS4xNjYtLjIwOGMuMzg4LS4wMDYuNzcyLjA3IDEuMTI4LjIyNS4zMTYuMTM0LjU4Ny4zNTcuNzc5LjY0Mi4xODYuMjgxLjI4My42MTIuMjc3Ljk1aC0xLjQwNWEuNzA5LjcwOSAwIDAwLS4yMjItLjU1Ny44NDQuODQ0IDAgMDAtLjU4OS0uMTk1Ljk2Ny45NjcgMCAwMC0uNjA3LjE2OC41MDguNTA4IDAgMDAtLjIxNy40MjIuNTI0LjUyNCAwIDAwLjI0MS40MWMuMjYyLjE2Ny41NDguMjk0Ljg0Ny4zNzcuMzQ2LjEwNC42OC4yNDQuOTk2LjQxNy42MzIuMzY0Ljk0OS44NjYuOTQ5IDEuNTA2YTEuNDMgMS40MyAwIDAxLS41NzkgMS4yMDVjLS4zODUuMjkyLS45MTQuNDM4LTEuNTg2LjQzOGEzLjE4NiAzLjE4NiAwIDAxLTEuMjg5LS4yNTIgMS45NzMgMS45NzMgMCAwMS0uODY4LS43QTEuODM0IDEuODM0IDAgMDE4IDE0LjY1OGgxLjQxNGEuOTEuOTEgMCAwMC4yNDEuNjk1Yy4xNjIuMTQ2LjQyNi4yMi43OTEuMjJhLjkxLjkxIDAgMDAuNTUtLjE1Mi41LjUgMCAwMC4yMTItLjQyMnoiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                       alt=""> &nbsp; {{ $t('voucher.shop_voucher') }}
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'product' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'product'">
                <el-card :shadow="type === 'product' ? 'always' : 'never'">
                  <img style="width: 40px; height: 40px;"
                       src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjYyNSA0LjM3NVY1aC02LjI1di0uNjI1YTMuMTI1IDMuMTI1IDAgMTE2LjI1IDB6TTMuNjIxIDVoMi41MDR2LS42MjVhNC4zNzUgNC4zNzUgMCAxMTguNzUgMFY1aDIuNTAzYTEuMjUgMS4yNSAwIDAxMS4yNDUgMS4xMzhsMS4xMjggMTIuNUExLjI1IDEuMjUgMCAwMTE4LjUwNiAyMEgyLjQ5MmExLjI1IDEuMjUgMCAwMS0xLjI0NS0xLjM2MmwxLjEyOS0xMi41QTEuMjUgMS4yNSAwIDAxMy42MiA1em03LjkxMSA4Ljc1YS43MDUuNzA1IDAgMDEuMDYzLjMyNy42MDcuNjA3IDAgMDEtLjI2LjUxNCAxLjExIDEuMTEgMCAwMS0uNjY5LjE4NWMtLjQ0NCAwLS43NjYtLjA5LS45NjMtLjI2OGExLjExIDEuMTEgMCAwMS0uMjk0LS44NDdINy42ODhjLS4wMDkuNDQxLjExNC44NzUuMzUxIDEuMjQ2LjI2My4zOC42My42NzYgMS4wNTguODUzLjQ5Ni4yMSAxLjAzLjMxNCAxLjU3LjMwNy44MTggMCAxLjQ2Mi0uMTc4IDEuOTMyLS41MzNhMS43NCAxLjc0IDAgMDAuNzA0LTEuNDY4YzAtLjc3OS0uMzg1LTEuMzktMS4xNTYtMS44MzRhNi4zMjIgNi4zMjIgMCAwMC0xLjIxMi0uNTA4IDMuODEyIDMuODEyIDAgMDEtMS4wMzItLjQ1OS42MzguNjM4IDAgMDEtLjI5NC0uNS42MTkuNjE5IDAgMDEuMjY0LS41MTNjLjIxNy0uMTUuNDc3LS4yMjIuNzQtLjIwNS4yNi0uMDE1LjUxNy4wNy43MTcuMjM4YS44NjQuODY0IDAgMDEuMjcuNjc3aDEuNzEyYTIuMDM0IDIuMDM0IDAgMDAtLjMzOC0xLjE1NiAyLjE2NSAyLjE2NSAwIDAwLS45NDktLjc4MiAzLjI5NSAzLjI5NSAwIDAwLTEuMzczLS4yNzMgMy44MDEgMy44MDEgMCAwMC0xLjQyLjI1M2MtLjM4NS4xNC0uNzIzLjM4NC0uOTc4LjcwNGExLjY4IDEuNjggMCAwMC0uMzQyIDEuMDQzYzAgLjc5My40NjEgMS40MTUgMS4zODQgMS44NjcuMzU1LjE3LjcyLjMxNiAxLjA5NS40MzcuMzMzLjA5NC42NDkuMjQuOTM1LjQzNC4wODkuMDcuMTYuMTYuMjA2LjI2MnoiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                       alt=""> &nbsp; {{ $t('voucher.product_voucher') }}
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
          </div>
          <div style="margin-top: 20px">
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'hide' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'hide'">
                <el-card :shadow="type === 'hide' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5Ljg3NSAzLjc1Yy4zNDUgMCAuNjI1LjI4LjYyNS42MjV2MTEuMjVjMCAuMzQ1LS4yOC42MjUtLjYyNS42MjVIMS4xMjVhLjYyNS42MjUgMCAwMS0uNjI1LS42MjVWMTVhMS4yNSAxLjI1IDAgMDAwLTIuNXYtMS4yNWExLjI1IDEuMjUgMCAwMDAtMi41VjcuNUExLjI1IDEuMjUgMCAwMC41IDV2LS42MjVjMC0uMzQ1LjI4LS42MjUuNjI1LS42MjVoMTguNzV6bS01LjEwMyA3Ljc0NGEuNzgyLjc4MiAwIDAxLjA3LjM2My42NzcuNjc3IDAgMDEtLjI4OC41N2MtLjIyLjE0Ny0uNDguMjE5LS43NDQuMjA2LS40OTQgMC0uODUxLS4xLTEuMDctLjI5OGExLjIzMSAxLjIzMSAwIDAxLS4zMjctLjk0aC0xLjkxMmMtLjAxLjQ5LjEyNi45NzEuMzkgMS4zODQuMjkyLjQyMi43Ljc1IDEuMTc1Ljk0Ny41NTEuMjMzIDEuMTQ1LjM1IDEuNzQ0LjM0MS45MSAwIDEuNjI1LS4xOTcgMi4xNDctLjU5MmExLjkzMiAxLjkzMiAwIDAwLjc4Mi0xLjYzYzAtLjg2Ni0uNDI4LTEuNTQ2LTEuMjg0LTIuMDM5YTcuMDIgNy4wMiAwIDAwLTEuMzQ3LS41NjUgNC4yMzYgNC4yMzYgMCAwMS0xLjE0Ny0uNTEuNzEuNzEgMCAwMS0uMzI2LS41NTQuNjg4LjY4OCAwIDAxLjI5NC0uNTdjLjI0LS4xNjYuNTMtLjI0Ny44MjEtLjIyOS4yOS0uMDE2LjU3NS4wNzkuNzk3LjI2NWEuOTU5Ljk1OSAwIDAxLjMuNzUyaDEuOTAzYTIuMjYgMi4yNiAwIDAwLS4zNzYtMS4yODQgMi40MDYgMi40MDYgMCAwMC0xLjA1NC0uODY5IDMuNjYgMy42NiAwIDAwLTEuNTI3LS4zMDQgNC4yMjQgNC4yMjQgMCAwMC0xLjU3Ny4yODIgMi40ODYgMi40ODYgMCAwMC0xLjA4Ny43ODJjLS4yNTMuMzMzLS4zODYuNzQxLS4zOCAxLjE1OSAwIC44OC41MTMgMS41NzIgMS41MzkgMi4wNzUuMzk0LjE4OC44LjM1IDEuMjE2LjQ4NC4zNy4xMDUuNzIuMjY4IDEuMDQuNDgzYS43ODIuNzgyIDAgMDEuMjI4LjI5ek01LjUgNWgxLjI1djIuNUg1LjVWNXptMCAzLjc1aDEuMjV2Mi41SDUuNXYtMi41em0xLjI1IDMuNzVINS41VjE1aDEuMjV2LTIuNXoiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                       alt=""> &nbsp; {{ $t('voucher.private_voucher') }}
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'shopee_live' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'shopee_live'">
                <el-card :shadow="type === 'shopee_live' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Il8yYjZhdnkzenVzdkpWYWMxREJxODhoIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjIxIDQuMjAzYzAtLjQtLjMyNC0uNzI1LS43MjUtLjcyNUgyLjg5MmMtLjQgMC0uNzI0LjMyNS0uNzI0LjcyNXYxMS41OTRjMCAuNC4zMjQuNzI1LjcyNC43MjVoMTEuNTk1Yy40IDAgLjcyNC0uMzI1LjcyNC0uNzI1VjQuMjAzek02LjUxNCA4LjAxOWMwLS41LjM0Ny0uNjk0Ljc1LS40NWwzLjI5MyAxLjk4NmMuNDEuMjQ3LjQwNC42NTggMCAuOTAybC0zLjI5MyAxLjk3NmMtLjQxMi4yNDQtLjc1LjA0LS43NS0uNDVWOC4wMTl6IiBmaWxsPSIjRUU0RDJEIj48L3BhdGg+PHBhdGggZD0iTTE4LjgzMyAxMi43MDdjMCAuODItLjcwMy45NjctMS4wNzIuNzQybC0xLjgyNi0uOTY1VjcuNTY1bDEuNzgxLTEuMDJjLjM2LS4yMTEgMS4xMS0uMDc0IDEuMTE3Ljc0NXY1LjQxN3oiIGZpbGw9IiNFRTREMkQiPjwvcGF0aD48L3N2Zz4="
                       alt=""> &nbsp; Voucher Shopee Live
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'shopee_video' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'shopee_video'">
                <el-card :shadow="type === 'shopee_video' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,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"
                       alt=""> &nbsp; Voucher Shopee Video
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
          </div>
          <div style="margin-top: 20px">
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'new_buyer' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'new_buyer'">
                <el-card :shadow="type === 'new_buyer' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4yNSAzLjc1QTMuNzQ5IDMuNzQ5IDAgMDExMC41IDcuNWEzLjc0OSAzLjc0OSAwIDAxLTMuNzUtMy43NUEzLjc0OSAzLjc0OSAwIDAxMTAuNSAwYTMuNzQ5IDMuNzQ5IDAgMDEzLjc1IDMuNzV6TTMgMTIuMTA3QzMgOS41NDIgNy45OTcgOC4yNSAxMC41IDguMjVjMi4wNDYgMCA1Ljc1OS44NjMgNy4wNDYgMi41OGE1IDUgMCAwMC02LjAxIDYuNzg0SDQuMjVjLS42OSAwLTEuMjUtLjU2LTEuMjUtMS4yNXYtNC4yNTd6bTkuNjU0IDUuNTA3YTQgNCAwIDEwNi45NDMtMy45NzcgNCA0IDAgMDAtNi45NDMgMy45Nzd6bTIuNDMtMS4zMjJjLjE2OS4xMjguMzM4LjIyNS41MDguMjkyYTEuNyAxLjcgMCAwMC41NTEuMDk5Yy4wNyAwIC4xMzctLjAwNi4xOTktLjAxOWEuNTc0LjU3NCAwIDAwLjE2LS4wNjguMzA3LjMwNyAwIDAwLjExMi0uMTA1LjI0OS4yNDkgMCAwMC4wMzgtLjE1NS4yMi4yMiAwIDAwLS4wNjktLjE2MS42MDQuNjA0IDAgMDAtLjE1NC0uMTMgMS40OTEgMS40OTEgMCAwMC0uMTk5LS4xIDQuNDU0IDQuNDU0IDAgMDAtLjE5Mi0uMDc0IDkuMTgxIDkuMTgxIDAgMDEtLjQ0Ni0uMTggMS44NTQgMS44NTQgMCAwMS0uNDE1LS4yNiAxLjMxMSAxLjMxMSAwIDAxLS4yOTgtLjM3MiAxLjA3IDEuMDcgMCAwMS0uMDkzLS41NDZjLjAwNC0uMTExLjAyOS0uMjI1LjA3NC0uMzQuMDUtLjExNi4xMi0uMjI0LjIxMS0uMzIzLjA5NS0uMDk5LjIxMy0uMTg0LjM1NC0uMjU0LjE0NC0uMDc0LjMxNi0uMTI0LjUxNC0uMTQ5di0uMzIyaC40MzR2LjMxNmMuMjYuMDI1LjQ4OC4wODcuNjgyLjE4Ni4xOTguMDk1LjM0Ny4xODYuNDQ2LjI3M2wtLjQ1OS42NDRhMS43MDIgMS43MDIgMCAwMC0uMzc4LS4xOCAxLjQ2IDEuNDYgMCAwMC0uNDUyLS4wOTljLS4xODYtLjAxMi0uMzIuMDE1LS40MDMuMDgxLS4wNzkuMDY2LS4xMi4xMzItLjEyNC4xOTggMCAuMDYyLjAxNi4xMTYuMDUuMTYyYS41LjUgMCAwMC4xMzYuMTIzYy4wNTguMDM0LjEyNC4wNjcuMTk4LjEuMDc1LjAyOS4xNDkuMDYuMjIzLjA5M2wuMDguMDNjLjE1OC4wNjcuMzEuMTQuNDYuMjE4LjE1Mi4wNzguMjg5LjE3MS40MDkuMjc5LjEyLjEwMy4yMTQuMjI1LjI4NS4zNjUuMDcuMTQuMTAzLjMwNC4wOTkuNDlhMS4xMzMgMS4xMzMgMCAwMS0uMDg3LjM5IDEuMDYgMS4wNiAwIDAxLS4yMy4zNTRjLS4wOTkuMTA3LS4yMjcuMTk4LS4zODQuMjcyLS4xNTcuMDc1LS4zNC4xMi0uNTUxLjEzN3YuNDIxaC0uNDM0di0uNDI3YTIuMDA3IDIuMDA3IDAgMDEtLjc0NC0uMTk5Yy0uMjEtLjExMS0uNC0uMjQ2LS41Ny0uNDAzbC40NTgtLjY1N3oiIGZpbGw9IiNFRTREMkQiLz48L3N2Zz4="
                       alt=""> &nbsp; {{ $t('voucher.new_buyer_voucher') }}
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'repeat_buyer' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'repeat_buyer'">
                <el-card :shadow="type === 'repeat_buyer' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,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"
                       alt=""> &nbsp; {{ $t('voucher.repeat_buyer_voucher') }}
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
            <div style="display: inline-block; width: 30%">
              <div :class="type === 'follow_prize' ? 'card-fixed-active' : 'card-fixed'"
                   @click="type = 'follow_prize'">
                <el-card :shadow="type === 'follow_prize' ? 'always' : 'never'">
                  <img style="width: 35px; height: 35px"
                       src="data:image/svg+xml;base64,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"
                       alt=""> &nbsp; {{ $t('voucher.follow_prize_voucher') }}
                </el-card>
              </div>
            </div>
            <div style="display: inline-block; width: 2%"></div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <table>
      <tbody>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.voucher_name') }}</div>
        </td>
        <td style="width: 600px">
          <br>
          <el-input v-model="form_voucher.name" style="width: 96%" size="mini"
                    :placeholder="$t('input.voucher_name')"></el-input>
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td><span style="color: #666; font-size: 12px">{{ $t('voucher.visible_to_buyers') }}</span></td>
      </tr>
      <tr v-if="array_to_set(['shop', 'product', 'hide', 'new_buyer', 'repeat_buyer']).has(type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.code') }}</div>
        </td>
        <td>
          <br>
          <el-input v-model="form_voucher.voucher_code" class="unset-left" style="width: 96%" size="mini"
                    :placeholder="$t('input.voucher_code')" maxlength="5" @input="m__validate_voucher_code"
                    show-word-limit
                    :disabled="is_update">
            <template slot="prepend">{{ prefix }}</template>
          </el-input>
        </td>
      </tr>
      <tr v-if="array_to_set(['shop', 'product', 'hide', 'new_buyer', 'repeat_buyer']).has(type)">
        <td>&nbsp;</td>
        <td>
          <div style="line-height: 30px">
            <strong class="text-primary" style="cursor: pointer; font-size: 13px"
                    @click="show_dialog.gen_voucher_code = true; (!auto_voucher_code) && m__gen_voucher_code()">
              {{ $t('voucher.gen_code_auto') }}
            </strong>
            <br>
            <span style="color: #666; font-size: 13px">{{ $t('voucher.please_enter') }}</span>
            <br>
            <span style="color: #666; font-size: 13px">{{ $t('voucher.complete_code_is') }}:</span>
            <span class="text-danger" style="font-weight: 700; font-size: 12px">{{
                prefix + form_voucher.voucher_code
              }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.usage_period') }}</div>
        </td>
        <td>
          <br>
          <el-date-picker
            style="width: 24%;"
            size="mini"
            type="date"
            :placeholder="$t('select.start_time')"
            v-model="form_voucher.start_time"
            :clearable="false"
            :disabled="is_update">
          </el-date-picker>
          <el-time-picker
            style="width: 20%;"
            size="mini"
            :placeholder="$t('select.hour')"
            format="HH:mm"
            v-model="form_voucher.el_start_time"
            :clearable="false"
            :disabled="is_update">
          </el-time-picker>
          <div style="display: inline-block; width: 5%; text-align: center">-</div>
          <el-date-picker
            style="width: 24%"
            size="mini"
            type="date"
            :placeholder="$t('select.end_time')"
            v-model="form_voucher.end_time"
            :clearable="false">
          </el-date-picker>
          <el-time-picker
            style="width: 20%;"
            size="mini"
            :placeholder="$t('select.hour')"
            format="HH:mm"
            v-model="form_voucher.el_end_time"
            :clearable="false">
          </el-time-picker>
        </td>
      </tr>
      <tr v-if="array_to_set(['new_buyer','repeat_buyer']).has(type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.target_buyer') }}</div>
        </td>
        <td>
          <br>
          <div v-if="type === 'new_buyer'" style="font-size: 14px">
            {{ $t('voucher.new_buyer_voucher_description') }}
          </div>
          <div v-if="type === 'repeat_buyer'" style="display: flex; gap: 10px; align-items: center">
            <div style="font-size: 12px">
              {{ $t('voucher.purchased') }}
            </div>

            <el-select v-model="shop_order_count" value="" size="mini" style="width: 100px">
              <el-option :value="2" :label="1"></el-option>
              <el-option :value="3" :label="2"></el-option>
            </el-select>

            <div style="font-size: 12px">
              {{ $t('voucher.purchased_times') }}
            </div>

            <el-select v-model="shop_order_count_period" value="" size="mini" style="width: 100px">
              <el-option :value="1" :label="30"></el-option>
              <el-option :value="2" :label="90"></el-option>
              <el-option :value="3" :label="180"></el-option>
              <el-option :value="4" :label="365"></el-option>
            </el-select>

            <div style="font-size: 12px">
              {{ $t('voucher.purchased_days') }}
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <br>
    <br>

    <div style="display: flex; align-items: center; margin-top: 30px">
      <div style="width: 260px">
        <strong style="font-size: 15px">{{ $t('voucher.reward_settings') }}</strong>
      </div>
      <div class="text-right" style="width: 600px; padding-right: 20px">
        <el-button type="primary" size="mini" @click="show_dialog.select_template = true">
          {{ $t('voucher.select_settings_template') }}
        </el-button>
      </div>
    </div>
    <br>
    <br>
    <table>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.reward_type') }}</div>
        </td>
        <td>
          <div style="width: 600px; padding-top: 7px">
            <el-radio v-model="form_voucher.rule.reward_type" size="small" :label="0" :disabled="is_update">
              {{ $t('base.discount') }}
            </el-radio>
            <el-radio v-model="form_voucher.rule.reward_type" size="small" :label="1" :disabled="is_update">
              {{ $t('voucher.coin_cashback') }}
            </el-radio>
          </div>
        </td>
      </tr>
      <template v-if="form_voucher.rule.reward_type === 0">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.discount_type') }} |
              {{ $t('voucher.amount') }}
            </div>
          </td>
          <td>
            <br>
            <div>
              <el-select style="width: 30%" size="mini" value="" v-model="v_or_d" :disabled="is_update">
                <el-option value="v" :label="$t('voucher.by_amount')"></el-option>
                <el-option value="d" :label="$t('voucher.by_percent')"></el-option>
              </el-select>
              <div style="display: inline-block; width: 5%"></div>
              <el-input v-model="form_voucher.value" class="unset-left" v-if="v_or_d === 'v'" type="number" size="mini"
                        :max="120000000" style="width: 60%" :placeholder="$t('input.amount')" :disabled="is_update">
                <template slot="prepend">{{ m__currency() }}</template>
              </el-input>
              <el-input v-model="form_voucher.discount" class="unset-left" v-if="v_or_d === 'd'" type="number"
                        size="mini" style="width: 60%" :placeholder="$t('input.percent')" :disabled="is_update">
                <template slot="prepend">%</template>
              </el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <div style="text-align: right; padding-right: 20px">
              <span style="font-size: 12px; color: red"
                    v-if="v_or_d === 'v'">{{ $t('voucher.by_amount') }}: {{ form_voucher.value | currency }}</span>
              <span style="font-size: 12px; color: red"
                    v-if="v_or_d === 'd'">{{ $t('voucher.by_percent') }}: {{ form_voucher.discount }}%</span>
            </div>
          </td>
        </tr>
      </template>
      <template v-if="form_voucher.rule.reward_type === 1">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.discount_type') }} |
              {{ $t('voucher.amount') }}
            </div>
          </td>
          <td>
            <br>
            <div>
              <el-select style="width: 30%" size="mini" value="d" :disabled="is_update">
                <el-option value="d" :label="$t('voucher.by_percent')"></el-option>
              </el-select>
              <div style="display: inline-block; width: 5%"></div>
              <el-input v-model="form_voucher.rule.coin_cashback_voucher.coin_percentage_real" class="unset-left"
                        type="number" size="mini" style="width: 60%" :placeholder="$t('input.percent')">
                <template slot="prepend">% {{ $t('voucher.coin_cashback') }}</template>
              </el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
          <span style="font-size: 12px; color: #666">
            {{
              $t('voucher.will_be_returned_message', {x: +form_voucher.rule.coin_cashback_voucher.coin_percentage_real ? form_voucher.rule.coin_cashback_voucher.coin_percentage_real : '-'})
            }}.
            </span>
          </td>
        </tr>
      </template>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;"> {{ $t('voucher.min_basket_price') }}</div>
        </td>
        <td>
          <br>
          <div>
            <el-input v-model="form_voucher.min_price" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')" :disabled="is_update"></el-input>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
        </td>
        <td>
          <div style="text-align: right; padding-right: 20px">
            <span style="font-size: 12px; color: red">{{ $t('base.value') }}: {{
                form_voucher.min_price | currency
              }}</span>
          </div>
        </td>
      </tr>
      <template
        v-if="form_voucher.rule.reward_type === 0 && this.v_or_d === 'd'">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_capped_amount') }}</div>
          </td>
          <td>
            <br>
            <div style="padding-top: 7px">
              <el-radio v-model="is_limit_0" label="y" :disabled="is_update">{{ $t('base.limited') }}</el-radio>
              <el-radio v-model="is_limit_0" label="n" :disabled="is_update">{{ $t('base.unlimited') }}</el-radio>
            </div>
          </td>
        </tr>
        <tr v-if="is_limit_0 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <el-input v-model="form_voucher.max_value" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')" :disabled="is_update"></el-input>
            <div style="height: 10px"></div>
          </td>
        </tr>
        <tr v-if="is_limit_0 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <div style="text-align: right; padding-right: 20px">
              <span style="font-size: 12px; color: red">{{ $t('base.value') }}: {{
                  form_voucher.max_value | currency
                }}</span>
            </div>
          </td>
        </tr>
      </template>
      <template v-if="form_voucher.rule.reward_type === 1">
        <tr>
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
            <br>
            <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_capped_amount') }}</div>
          </td>
          <td>
            <br>
            <div style="padding-top: 7px">
              <el-radio v-model="is_limit_1" label="y" :disabled="is_update">{{ $t('base.limited') }}</el-radio>
              <el-radio v-model="is_limit_1" label="n" :disabled="is_update">{{ $t('base.unlimited') }}</el-radio>
            </div>
          </td>
        </tr>
        <tr v-if="is_limit_1 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <el-input v-model="form_voucher.rule.coin_cashback_voucher.max_coin" type="number" size="mini"
                      style="width: 96%" :placeholder="$t('input.value')" :disabled="is_update"></el-input>
            <span style="font-size: 12px; color: #666">{{ $t('voucher.equals_to') }}:</span>
            <strong
              style="font-size: 12px; color: #666">{{
                +form_voucher.rule.coin_cashback_voucher.max_coin ? form_voucher.rule.coin_cashback_voucher.max_coin : '-'
              }}
              Shopee {{ $t('voucher.coins') }}</strong>
          </td>
        </tr>
        <tr v-if="is_limit_1 === 'y'">
          <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          </td>
          <td>
            <div style="text-align: right; padding-right: 20px">
              <span style="font-size: 12px; color: red">{{ $t('base.value') }}: {{
                  form_voucher.rule.coin_cashback_voucher.max_coin | currency
                }}</span>
            </div>
          </td>
        </tr>
      </template>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_usage_quantity') }}</div>
        </td>
        <td>
          <br>
          <div>
            <el-input v-model="form_voucher.usage_quantity" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')"></el-input>
          </div>
        </td>
      </tr>
      <tr v-if="['shop', 'product', 'hide'].includes(this.type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.max_distribution') }}</div>
        </td>
        <td>
          <br>
          <div>
            <el-input v-model="form_voucher.rule.usage_limit_per_user" type="number" size="mini" style="width: 96%"
                      :placeholder="$t('input.value')" :disabled="is_update"></el-input>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          &nbsp;
        </td>
        <td style="text-align: right;">
          <br>
          <br>
          <el-button type="primary" size="mini" @click="show_dialog.create_voucher_template = true"
                     style="margin-right: 20px">
            {{ $t('voucher.save_settings_template') }}
          </el-button>
        </td>
      </tr>
    </table>
    <br>
    <br>

    <strong style="font-size: 15px">{{ $t('voucher.voucher_display_title') }}</strong>
    <br>
    <br>
    <table>
      <tr v-if="['shop', 'product', 'new_buyer', 'repeat_buyer', 'follow_prize'].includes(type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <div style=" padding-right: 20px; font-size: 14px;">{{ $t('voucher.display_setting') }}</div>
        </td>
        <td>
          <div style="width: 600px; padding-top: 7px">
            <div v-if="array_to_set(['new_buyer', 'repeat_buyer', 'follow_prize']).has(type)"
                 style="font-size: 14px; font-weight: 500">
              {{ $t('voucher.display_on_all_pages') }}
              <br>
              <br>
              {{ $t('product.all') }}
            </div>
            <div v-else>
              <el-radio v-model="form_voucher.rule.voucher_landing_page" :label="1">
                {{ $t('voucher.display_on_all_pages') }}
              </el-radio>
              <el-radio v-model="form_voucher.rule.voucher_landing_page" :label="0">
                {{ $t('voucher.shared_through_code') }}
              </el-radio>
            </div>
          </div>
        </td>
      </tr>
      <tr v-if="!array_to_set(['new_buyer', 'repeat_buyer', 'follow_prize']).has(type)">
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
          <div style=" padding-right: 20px; font-size: 14px;">
            {{ $t('voucher.applicable_products') }}
            <template v-if="['hide', 'shopee_live', 'shopee_video'].includes(type)">
              <br><span class="text-danger">({{ $t('base.not_required') }})</span>
            </template>
          </div>
        </td>
        <td>
          <div style="width: 600px;">
            <br>
            <template v-if="type === 'shop'">
              <span style="font-size: 14px">{{ $t('product.all') }}</span>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="show_dialog.select_product = true">
                {{ $t('base.add_products') }}
              </el-button>
              <el-button type="info" size="mini" @click="m__show_selected_product">
                {{ $t('voucher.show_selected_products') }} ({{ form_voucher.rule.items.length }}
                {{ $t('base.products') }})
              </el-button>
            </template>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 260px; padding-right: 20px !important; text-align: right; ">
          <br>
        </td>
        <td>
          <div style="width: 600px; text-align: right; padding-right: 20px">
            <br>
            <br>
            <br>
            <el-button type="info" size="mini" icon="el-icon-refresh" @click="form_voucher = clone(temp)">Refresh
            </el-button>
            <el-button v-if="component_state === 'create'" type="primary" size="mini" icon="el-icon-check"
                       :loading="loading.create_voucher" @click="m__create_voucher()">
              {{ $t('voucher.confirm_and_create') }}
            </el-button>
            <el-button v-if="component_state === 'update_file'" type="primary" size="mini" icon="el-icon-check"
                       :loading="loading.update_file" @click="m__update_voucher_file()">
              {{ $t('voucher.confirm_and_save_file') }}
            </el-button>
          </div>
        </td>
      </tr>
    </table>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.selected_list"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-table :data="product_selected_list">
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                   style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.sold | currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable>
            <template slot-scope="scope">{{ scope.row.stock | currency }}</template>
          </el-table-column>
          <el-table-column :prop="$t('base.action')" width="100px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__remove_selected_product(scope.row.itemid)">
                <strong class="text-danger">{{ $t('base.delete') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.select_product"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading_product"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}</strong></p>
            <p v-else><strong style="font-size: 18px">{{ $t('select.products') }}
              <a href="javascript:void(0)" @click="m__get_product()">({{ $t('base.update') }})</a></strong></p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left" label="#">
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected"
                           :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                   style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.sold')" prop="sold" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.sold | currency }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.stock | currency }}</template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 15px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">{{
                $t('base.show_eligible_products_only')
              }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ c__product_filter_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_select_product"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="show_dialog.select_template"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('voucher.settings_template') }}</strong>

        <div style="margin-top: 30px">
          <el-table :data="voucher_templates">
            <el-table-column :label="$t('voucher.template_name')" prop="name"></el-table-column>
            <el-table-column :label="$t('base.optional')" width="120px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__use_voucher_template(scope.row)">
                  <strong class="text-primary">{{ $t('base.use') }}</strong>
                </el-button>
                <el-button v-if="scope.row._id" type="text" size="mini" @click="m__use_voucher_template(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="show_dialog.gen_voucher_code"
               custom-class="no-body">
      <div slot="title" style="padding: 10px 10px 10px 20px;">
        <strong class="strong-title">{{ $t('voucher.gen_code_auto') }}</strong>

        <div style="margin-top: 30px">
          <div style="display: flex">
            <div style="flex: 2; display: flex; flex-direction: column; gap: 20px">
              <el-radio v-model="gen_type" label="AMMYY">{{ $t('base.format') }} AMMYY</el-radio>
              <el-radio v-model="gen_type" label="MMYYA">{{ $t('base.format') }} MMYYA</el-radio>
              <el-radio v-model="gen_type" label="AAADD">{{ $t('base.format') }} AAADD</el-radio>
              <el-radio v-model="gen_type" label="DDDAA">{{ $t('base.format') }} DDDAA</el-radio>
            </div>
            <div style="flex: 1; line-height: 30px">
              MM = {{ $t('base.month') }}
              <br>
              YY = {{ $t('base.year') }}
              <br>
              A = {{ $t('base.letter') }}
              <br>
              D = {{ $t('base.digit') }}
            </div>
          </div>
          <div style="margin-top: 20px">
            <div>
              <el-radio v-model="gen_type" label="custom">{{ $t('voucher.custom') }}</el-radio>
              <el-input v-if="gen_type === 'custom'" v-model="auto_voucher_custom" size="mini" style="width: 150px"
                        maxlength="5" show-word-limit :placeholder="$t('input.format')"></el-input>
              <el-button v-if="gen_type === 'custom'" type="primary" size="mini" style="margin-left: 10px"
                         @click="m__gen_voucher_code(gen_type)">
                {{ $t('voucher.gen_code') }}
              </el-button>
            </div>
          </div>
        </div>

        <div style="margin-top: 45px; display: flex; align-items: center">
          <div v-if="auto_voucher_code" style="padding-left: 5px; display: flex; gap: 15px; align-items: center">
            <div
              style="font-size: 16px; background-color: #dddddd; padding: 5px 30px; font-weight: bold; min-width: 130px; text-align: center">
              {{ auto_voucher_code }}
            </div>
            <div style="padding-top: 2px">
              <i style="cursor: pointer; font-size: 20px !important;" class="el-icon-copy-document"
                 @click="copy_text(auto_voucher_code); form_voucher.voucher_code = auto_voucher_code; show_dialog.gen_voucher_code = false"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_voucher_template" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('voucher.template_name') }}</p>
        <el-input size="mini" :placeholer="$t('input.template_name')" v-model="voucher_template_name"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.create_voucher_template"
                     @click="m__create_voucher_template()">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {drop as _drop, orderBy as _orderBy, take as _take} from 'lodash'
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'page__create_voucher',

  mixins: [fix_ads_mixins],

  props: {
    shop: {},
    seller: {},
    product_list: {
      type: Array,
      default: []
    },
    selected_product_ids: {
      type: Array,
      default: []
    },
    loading_product: {
      type: Boolean,
      default: false
    },
    copy_from_id: null,
    copy_from_file: null,
    has_new_voucher: false,
    voucher_list: {
      type: Array,
      default: []
    },
    update_file_id: null,
    is_update: false,
    component_state: null
  },

  data() {
    return {
      prefix: '',
      type: 'shop',
      v_or_d: 'v',
      is_limit_0: 'n',
      is_limit_1: 'n',
      temp: {
        name: '',
        voucher_code: '',
        start_time: this.dayjs().add(10, 'm').toDate(),
        el_start_time: this.dayjs().add(10, 'm').toDate(),
        end_time: this.dayjs().add(26, 'h').toDate(),
        el_end_time: this.dayjs().add(26, 'h').toDate(),
        rule: {
          backend_created: 0,
          voucher_landing_page: 1,
          hide: 0,
          items: [],
          reward_type: 0,
          coin_cashback_voucher: {
            coin_percentage_real: null,
            max_coin: null
          },
          display_from: null,
          exclusive_channel_type: null,
          usage_limit_per_user: 1,
          display_voucher_early: false,
          choose_users: {
            shop_order_count: 0,
            shop_order_count_period: 0
          }
        },
        usage_quantity: 10,
        value: null,
        discount: null,
        max_value: null,
        min_price: null
      },
      form_voucher: {},
      loading: {
        create_voucher: false,
        create_voucher_template: false,
        update_file: false
      },
      show_dialog: {
        select_product: false,
        selected_list: false,
        select_template: false,
        gen_voucher_code: false,
        create_voucher_template: false
      },
      product_selected_list: [],
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: true
      },
      product_sort_option: {
        order: null,
        prop: null
      },
      detail_voucher: null,

      voucher_templates: [
        {
          name: this.$t('voucher.template_name_1'),
          v_or_d: 'v',
          value: 500000,
          discount: null,
          min_price: 0,
          usage_quantity: 1,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_2'),
          v_or_d: 'v',
          value: 200000,
          discount: null,
          min_price: 0,
          usage_quantity: 3,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_3'),
          v_or_d: 'v',
          value: 100000,
          discount: null,
          min_price: 0,
          usage_quantity: 5,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_4'),
          v_or_d: 'v',
          value: 50000,
          discount: null,
          min_price: 0,
          usage_quantity: 10,
          is_limit_0: 'n',
          max_value: null,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_5'),
          v_or_d: 'd',
          discount: 5,
          value: null,
          min_price: 100000,
          usage_quantity: 100,
          is_limit_0: 'y',
          max_value: 15000,
          reward_type: 0
        },
        {
          name: this.$t('voucher.template_name_6'),
          v_or_d: 'd',
          discount: 25,
          value: null,
          min_price: 150000,
          usage_quantity: 100,
          is_limit_0: 'y',
          max_value: 25000,
          reward_type: 0
        }
      ],

      gen_type: 'AMMYY',
      auto_voucher_code: '',
      auto_voucher_custom: '',

      voucher_template_name: '',

      shop_order_count: 2,
      shop_order_count_period: 1,
    }
  },

  async beforeMount() {
    this.prefix = this.shop.username.split('').filter(i => /[a-z0-9]/ig.test(i)).slice(0, 4).join('').toUpperCase()

    this.form_voucher = this.clone(this.temp)

    if (this.copy_from_id) {
      const response = await this.seller.marketing_get_voucher_detail(this.copy_from_id)
      if (response && response.data && response.data.data) {
        const voucher = response.data.data
        console.log('voucher', voucher)
        this.form_voucher.name = voucher.name
        this.form_voucher.min_price = +voucher.min_price
        this.form_voucher.max_value = +voucher.max_value
        this.is_limit_0 = +voucher.max_value ? 'y' : 'n'
        this.form_voucher.value = +voucher.value
        this.form_voucher.discount = +voucher.discount
        this.form_voucher.usage_quantity = +voucher.usage_quantity
        if (voucher.value) {
          this.v_or_d = 'd'
        }

        const second_diff = this.dayjs(voucher.end_time * 1000).diff(voucher.start_time * 1000, 'second')
        this.form_voucher.start_time = new Date()
        this.form_voucher.end_time = this.dayjs().add(second_diff, 'second')

        if (voucher.voucher_code.startsWith('VIDEO')) {
          this.type = 'shopee_video'
        } else if (voucher.voucher_code.startsWith('LIVE')) {
          this.type = 'shopee_live'
        } else {
          if (voucher.rule.hide) {
            this.type = 'hide'
          } else {
            if (voucher.rule.shopids) {
              this.type = 'shop'
            } else {
              this.type = 'product'
            }
          }
        }

        for (const key of Object.keys(this.temp.rule)) {
          this.form_voucher.rule[key] = voucher.rule[key] || this.temp.rule[key]
        }

        if (this.is_update) {
          this.form_voucher.voucher_code = voucher.voucher_code.replace(this.prefix, '')
          this.form_voucher.start_time = this.form_voucher.el_start_time = new Date(voucher.start_time * 1000)
          this.form_voucher.end_time = this.form_voucher.el_end_time = new Date(voucher.end_time * 1000)
        }
      }
    }

    if (this.copy_from_file) {
      const voucher = this.clone(this.copy_from_file.data)
      console.log('file', voucher)
      this.form_voucher.name = voucher.name
      this.form_voucher.min_price = +voucher.min_price
      this.form_voucher.max_value = +voucher.max_value
      this.is_limit_0 = +voucher.max_value ? 'y' : 'n'
      this.form_voucher.value = +voucher.value
      this.form_voucher.discount = +voucher.discount
      this.form_voucher.usage_quantity = +voucher.usage_quantity
      if (+voucher.value && +voucher.value > 0) {
        this.v_or_d = 'v'
      }

      const second_diff = this.dayjs(voucher.end_time * 1000).diff(voucher.start_time * 1000, 'second')
      this.form_voucher.start_time = new Date()
      this.form_voucher.end_time = this.dayjs().add(second_diff, 'second')

      if (voucher.voucher_code.startsWith('VIDEO')) {
        this.type = 'shopee_video'
      } else if (voucher.voucher_code.startsWith('LIVE')) {
        this.type = 'shopee_live'
      } else {
        if (voucher.rule.hide) {
          this.type = 'hide'
        } else {
          if (voucher.rule.shopids) {
            this.type = 'shop'
          } else {
            this.type = 'product'
          }
        }
      }

      for (const key of Object.keys(this.temp.rule)) {
        this.form_voucher.rule[key] = voucher.rule[key] || this.temp.rule[key]
      }
    }

    if (this.selected_product_ids && this.selected_product_ids.length) {
      this.form_voucher.rule.items = this.selected_product_ids.map(i => ({itemid: +i}))
      this.type = 'product'
    }

    await this.m__get_voucher_template()
    await this.m__get_product()
  },

  watch: {
    'gen_type': function () {
      this.m__gen_voucher_code()
    },

    'form_voucher.rule.usage_limit_per_user': function () {
      if (this.form_voucher.rule.usage_limit_per_user > 5) {
        this.form_voucher.rule.usage_limit_per_user = 5
      }
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list

      if (this.product_filter.available) {
        result = result.filter(i => i.stock > 0)
      }

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      result = result.filter(i => this.form_voucher.rule.items && !this.form_voucher.rule.items.some(ii => ii.itemid === i.itemid))

      const words = this.remove_unicode(this.product_filter.keyword)
      return result.filter(item => this.remove_unicode(item.name).includes(words))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)
      return _take(_drop(this.c__product_filter_list, skip), limit)
    }
  },

  methods: {
    async m__update_voucher_file() {
      this.loading.update_file = true

      const voucher = this.clone(this.copy_from_file.data)
      voucher.name = this.form_voucher.name
      voucher.min_price = +this.form_voucher.min_price
      voucher.max_value = +this.form_voucher.max_value
      voucher.value = +this.form_voucher.value
      voucher.discount = +this.form_voucher.discount
      voucher.usage_quantity = +this.form_voucher.usage_quantity

      for (const key of Object.keys(this.temp.rule)) {
        voucher.rule[key] = this.form_voucher.rule.hasOwnProperty(key) ? this.form_voucher.rule[key] : this.temp.rule[key]
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_file/update', {
          file_id: this.copy_from_file._id,
          name: this.copy_from_file.name,
          data: voucher
        }, this.cf())

        this.$emit('m__get_product')
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.update_file = false
      }
    },

    async m__get_voucher_template() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_template/get', {}, this.cf())
      for (const item of response.body.data) {
        this.voucher_templates.push({
          _id: item._id,
          name: item.filename,
          ...item.data
        })
      }
    },

    async m__create_voucher_template() {
      if (!this.voucher_template_name) {
        this.ntf_w(this.$t('required.template_name'))
        return
      }

      this.loading.create_voucher_template = true

      // this.v_or_d = template.v_or_d
      // this.form_voucher.value = template.value
      // this.form_voucher.min_price = template.min_price
      // this.form_voucher.discount = template.discount
      // this.form_voucher.usage_quantity = template.usage_quantity
      // this.is_limit_0 = template.is_limit_0
      // this.form_voucher.max_value = template.max_value
      // this.form_voucher.rule.reward_type = template.reward_type

      const form = {
        filename: this.voucher_template_name,
        data: {
          v_or_d: this.v_or_d,
          value: this.form_voucher.value,
          min_price: this.form_voucher.min_price,
          discount: this.form_voucher.discount,
          usage_quantity: this.form_voucher.usage_quantity,
          is_limit_0: this.is_limit_0,
          max_value: this.form_voucher.max_value,
          reward_type: this.form_voucher.rule.reward_type
        },
        shop_id: this.shop._id
      }
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_template/create', form, this.cf())
      await this.m__get_voucher_template()
      this.loading.create_voucher_template = false
      this.show_dialog.create_voucher_template = false
      this.$t('base.save_success')
    },

    m__gen_voucher_code() {
      const format = this.gen_type === 'custom'
        ? this.auto_voucher_custom
        : this.gen_type

      if (!format) return

      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const random_letter = () => letters[Math.floor(Math.random() * letters.length)]
      const random_digit = () => Math.floor(Math.random() * 10).toString()
      const current_month = this.dayjs().format('MM')
      const current_year = this.dayjs().format('YY')

      this.auto_voucher_code = format
        .replace(/A/g, random_letter)
        .replace(/D/g, random_digit)
        .replace(/MM/g, current_month)
        .replace(/YY/g, current_year)

      console.log(this.auto_voucher_code)
    },

    m__use_voucher_template(template) {
      this.v_or_d = template.v_or_d
      this.form_voucher.value = template.value
      this.form_voucher.min_price = template.min_price
      this.form_voucher.discount = template.discount
      this.form_voucher.usage_quantity = template.usage_quantity
      this.is_limit_0 = template.is_limit_0
      this.form_voucher.max_value = template.max_value
      this.form_voucher.rule.reward_type = template.reward_type

      this.show_dialog.select_template = false
    },

    m__validate_voucher_code() {
      this.form_voucher.voucher_code = this.form_voucher.voucher_code.split('').filter(i => /[a-z0-9]/ig.test(i)).join('').toUpperCase()
    },

    async m__create_voucher() {
      this.loading.create_voucher = true

      try {
        if (!this.form_voucher.name) {
          this.ntf_w(this.$t('required.voucher_name'))
          return
        }
        if (this.array_to_set(['shop', 'product', 'hide', 'new_buyer', 'repeat_buyer']).has(this.type) && !this.form_voucher.voucher_code) {
          this.ntf_w(this.$t('required.voucher_code'))
          return
        }
        if (this.form_voucher.voucher_code.length > 5) {
          this.ntf_w(this.$t('required.voucher_max_x_length', {x: '5'}))
          return
        }
        if (!this.form_voucher.start_time) {
          this.ntf_w(this.$t('required.start_time'))
          return
        }
        if (!this.form_voucher.end_time) {
          this.ntf_w(this.$t('required.end_time'))
          return
        }

        this.form_voucher.start_time = this.dayjs(this.form_voucher.start_time).hour(this.dayjs(this.form_voucher.el_start_time).hour()).toDate()
        this.form_voucher.start_time = this.dayjs(this.form_voucher.start_time).minute(this.dayjs(this.form_voucher.el_start_time).minute()).toDate()
        this.form_voucher.end_time = this.dayjs(this.form_voucher.end_time).hour(this.dayjs(this.form_voucher.el_end_time).hour()).toDate()
        this.form_voucher.end_time = this.dayjs(this.form_voucher.end_time).minute(this.dayjs(this.form_voucher.el_end_time).minute()).toDate()
        if (Math.floor(new Date(this.form_voucher.end_time).getTime() / 1000) - Math.floor(new Date(this.form_voucher.start_time).getTime() / 1000) < 3600) {
          this.ntf_w(this.$t('voucher.at_least_1_day'))
          return
        }

        if (this.form_voucher.rule.reward_type === 0) {
          if (this.v_or_d === 'v' && !this.form_voucher.value) {
            this.ntf_w(this.$t('required.discount_price'))
            return
          }
          if (this.v_or_d === 'v' && +this.form_voucher.discount > +this.form_voucher.min_price) {
            this.ntf_w(this.$t('voucher.discount_gt_min'))
            return
          }
          if (this.v_or_d === 'd' && !this.form_voucher.discount) {
            this.ntf_w(this.$t('required.discount_percent'))
            return
          }
          if (this.is_limit_0 === 'y' && !this.form_voucher.max_value) {
            this.ntf_w(this.$t('voucher.required_max_capped_amount'))
            return
          }
        }

        if (this.form_voucher.rule.reward_type === 1) {
          if (!this.form_voucher.rule.coin_cashback_voucher.coin_percentage_real) {
            this.ntf_w(this.$t('voucher.required_coin_cashback'))
          }
          if (this.is_limit_1 === 'y' && !this.form_voucher.rule.coin_cashback_voucher.max_coin) {
            this.ntf_w(this.$t('voucher.required_max_coin_cashback'))
            return
          }
        }

        if (!this.form_voucher.usage_quantity) {
          this.ntf_w(this.$t('voucher.required_usage_quantity'))
          return
        }
        if (this.type === 'product' && !this.form_voucher.rule.items.length) {
          this.ntf_w(this.$t('required.select_products'))
          return
        }

        // TODO: format
        const form = this.clone(this.form_voucher)

        form.voucher_code = this.prefix + form.voucher_code

        if (this.type === 'shop') {
          form.rule.items = []
        }

        if (this.dayjs(new Date(form.start_time)).isBefore(this.dayjs(), 's')) {
          form.start_time = this.dayjs().unix()
        } else {
          form.start_time = Math.floor(new Date(form.start_time).getTime() / 1000)
        }

        if (this.dayjs(new Date(form.end_time)).isBefore(this.dayjs(), 's')) {
          form.end_time = this.dayjs().add(1, 'd').unix()
        } else {
          form.end_time = Math.floor(new Date(form.end_time).getTime() / 1000)
        }

        if (form.rule.reward_type === 0) {
          form.rule.coin_cashback_voucher.coin_percentage_real = null
          form.rule.coin_cashback_voucher.max_coin = null

          if (this.v_or_d === 'v') {
            form.value = +form.value
            form.discount = null
            form.max_value = null
            this.is_limit_0 = 'n'
          } else {
            form.value = null
            form.discount = +form.discount
          }
          if (this.is_limit_0 === 'y') {
            form.max_value = +form.max_value
          } else {
            form.max_value = null
          }
        }

        if (form.rule.reward_type === 1) {
          form.max_value = form.discount = form.value = null

          form.rule.coin_cashback_voucher.coin_percentage_real = +form.rule.coin_cashback_voucher.coin_percentage_real
          if (this.is_limit_1 === 'y') {
            form.rule.coin_cashback_voucher.max_coin = +form.rule.coin_cashback_voucher.max_coin
          } else {
            form.rule.coin_cashback_voucher.max_coin = null
          }
        }

        if (form.rule.voucher_landing_page === 1) {
          form.rule.hide = 0
        } else {
          form.rule.hide = 1
        }

        if (this.type === 'hide') {
          form.rule.hide = 1
        }

        if (this.type === 'shopee_live') {
          form.rule.exclusive_channel_type = 1
          form.voucher_code = null
        }
        if (this.type === 'shopee_video') {
          form.rule.exclusive_channel_type = 2
          form.voucher_code = null
        }

        if (this.type === 'new_buyer') {
          form.rule.choose_users.shop_order_count = 1
          form.rule.choose_users.shop_order_count_period = 0
        }
        if (this.type === 'repeat_buyer') {
          form.rule.choose_users.shop_order_count = this.shop_order_count
          form.rule.choose_users.shop_order_count_period = this.shop_order_count_period
        }

        form.min_price = +form.min_price || 0
        form.usage_quantity = +form.usage_quantity

        if (this.is_update && this.copy_from_id) {
          form['voucher_id'] = +this.copy_from_id
          form['start_time'] = this.dayjs().unix()
        }

        form.rule.usage_limit_per_user = +form.rule.usage_limit_per_user

        delete form.el_start_time
        delete form.el_end_time

        console.log(form)
        let create_response = null

        if (this.type === 'follow_prize') {
          const prize_form = {
            shopid: +this.shop.shop_id,
            follow_prize_name: form.name,
            start_time: +form.start_time,
            end_time: +form.end_time,
            quota: +form.usage_quantity,
            min_spend: +form.min_price,
            reward_type: +form.rule.reward_type,
          }

          if (prize_form.reward_type === 0) {
            prize_form['discount'] = {}
            if (this.v_or_d === 'v') {
              prize_form.discount = {value: +form.value}
            }
            if (this.v_or_d === 'd') {
              prize_form.discount = {percentage: +form.discount}
              if (this.is_limit_0 === 'y') {
                prize_form.cap = +form.max_value
              }
            }
          }

          if (prize_form.reward_type === 1) {
            prize_form['coin_cash_back'] = {}
            prize_form.coin_cash_back.percentage = +form.rule.coin_cashback_voucher.coin_percentage_real
            if (this.is_limit_1 === 'y') {
              prize_form.cap = +form.rule.coin_cashback_voucher.max_coin
            }
          }

          create_response = await this.seller.marketing_create_follow_prize(prize_form)
        } else {
          create_response = await this.seller.marketing_create_voucher(form, this.is_update)
        }

        if (create_response.data.code === 0) {
          this.ntf_s(this.$t('voucher.create_success'))
          // this.form_voucher.name = ''
          // this.form_voucher.code = ''
          this.$emit('update:has_new_voucher', true)
        } else {
          let message = this.$t('voucher.error_message') + ': ' + create_response.data.message

          if (create_response.data.message === 'voucher prefix already exist') message = this.$t('voucher.already_exist_message')
          if (create_response.data.message === 'fe param error') message = this.$t('voucher.param_error_message')

          this.ntf_w(message)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.create_voucher = false
      }
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__get_product() {
      this.$emit('m__get_product')
    },

    m__confirm_select_product() {
      this.form_voucher.rule.items = this.c__product_filter_list.filter(i => i.selected).map(i => ({itemid: i.itemid}))
      this.show_dialog.select_product = false
    },

    m__show_selected_product() {
      this.product_selected_list = []

      for (const item of this.form_voucher.rule.items) {
        const product_found = this.product_list.find(i => i.itemid === item.itemid)
        if (product_found) this.product_selected_list.push(product_found)
      }
      this.show_dialog.selected_list = true
    },

    m__remove_selected_product(item_id) {
      this.product_selected_list = this.product_selected_list.filter(i => i.itemid !== item_id)
      this.form_voucher.rule.items = this.form_voucher.rule.items.filter(i => i.itemid !== item_id)
    }
  }
}
</script>

<style>
.unset-left input {
  border-left: none !important;
  border-top-left-radius: unset !important;
  border-bottom-left-radius: unset !important;
}

.unset-left .el-input-group__prepend {
  border: 1px solid #c0c4cc;
}

.page__create_voucher table td {
  padding: 5px 0 !important;
}

.page__create_voucher input {
  padding-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/voucher/create.vue